import { Col, Row } from 'antd'
import { useFormikContext } from 'formik'

import { CodeSelect } from 'features/Procedure/features/treatments/components/code-select/code-select'
import type { EmrCodeItem } from 'features/Procedure/state/procedure-api.type'
import { ProcedureTypeCode } from 'features/Procedure/state/procedure.type'
import type { FormValues } from './schema'

type Props = {
  isBilled?: boolean
}

export const ManageICD = ({ isBilled = false }: Props) => {
  const { values, errors, setFieldValue } = useFormikContext<FormValues>()

  const getErrorMessage = (error: any): string | undefined => {
    if (!error) return undefined
    if (typeof error === 'string') return error
    if (error?.message) return error.message
    return undefined
  }

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24}>
        <CodeSelect
          required
          label='ICD'
          codeType={ProcedureTypeCode.ICD10}
          size='large'
          value={values.icd10_codes[0] as EmrCodeItem | null}
          onChange={(newValue) => setFieldValue('icd10_codes', [newValue])}
          placeholder='Search ICD codes'
          disabled={isBilled}
          error={getErrorMessage(errors.icd10_codes)}
        />
      </Col>
    </Row>
  )
}
